<template>
	<div class="tail_list" v-loading="loadQueue" element-loading-text="加载中">
		<div class="tab-title" >
			<span>跟踪队列</span> 
			<span class="follw_Q">
				<a @click="selectAll">全选</a>
				<a @click="invertSelect">反选</a>
				<a @click="removeSelect">删除</a>
			</span>
			
		</div>
		  <div class=" tail_main">		
		  	 <dl v-for="vehicle in vehicles">
				  <a  class="btn_check" @click="removeToMap(vehicle)" data-toggle="tooltip" data-placement="bottom" title="移入地图"></a>
				  <dt><span>{{vehicle.vehicleId}}</span> 
				  	<em >
				  		<input v-bind:ref="'checkbox'+vehicle.id" v-show="vehicle.lockFlg!=1" class="company_check" type="checkbox" v-model="vehicle.checked" v-on:change="checked(vehicle)" >
				  	</em> 
				  	<em>
				  		<a v-show="vehicle.lockFlg==1" class="ico_lock01 toggle" @click="lock(vehicle)" data-toggle="tooltip" data-placement="bottom" title="解锁"></a> 
				  	    <a v-show="vehicle.lockFlg!=1" class="ico_lock02 toggle" @click="lock(vehicle)" data-toggle="tooltip" data-placement="bottom" title="锁定"></a>
				    </em>
				  </dt>
				  <dd><span>{{vehicle.plateNumber}}</span><em>时速: {{vehicle.speed}} km/h</em></dd>
				  <dd><span>{{vehicle.ownerName}}</span><em>GPS</em></dd>
			  </dl>	
			  <laypage :pages="pagesTotal" ref="laypg" :jump="cb" :groups="pagesTotal > 3 ? 3 : pagesTotal" :first="first" :last="last" :prev="prev" :next="next" class="laypage"></laypage>	
		  </div>
        <div class="track_bottom_btn">
        	<i><a class="ico_01" @click="removeAll">清空队列</a></i>
        </div>
	</div>
</template>

<script>
	import Laypage from 'components/common/vueLaypage/Laypage'
	import { OPERATE_EXCEPTION, OPERATE_SUCCESS, SAVE_ENSURE } from 'static/message'
	export default{
		data(){
			return {
				vehicles:[],
				totalVehicles:[],
				url:'/monitor/track/tracks/0',
				selectCount:0,
				selectVehicles:[],
				loadQueue:false,
				pagesTotal:0, //总页数
		        first:false, //不显示首页
		        last:false,	//不显示尾页
		        prev: '上一页',
		        next: '下一页'
			}
		},
		components:{
			Laypage
		},
		beforeMount() {
			this.getQueue(1);
		},
		mounted(){
			$(function () {//启用tooltip
				$('[data-toggle="tooltip"]').tooltip()
			})
		},
		updated(){
			$(function () {//启用tooltip
				$('[data-toggle="tooltip"]').tooltip()
			})
			$('.toggle').hover(function(){
				$(this).attr('title',$(this).attr('title')).tooltip('fixTitle').tooltip('show')
			})
		},
		destroyed(){
			$('[data-toggle="tooltip"]').tooltip('hide')
		},
		methods:{
			cb(page){
				this.getQueue(page)
			},
			//刷新组件
			refresh(){
				this.getQueue(1);
			},
			//获取队列信息
			getQueue(num){
				this.loadQueue = true
				this.$http.get(process.env.API_ROOT + this.url,{params:{page_index:num}})
				.then( res => {
					if(res.body.success){
						this.$store.dispatch('notLoadToMap')
						this.loadQueue = false
					//	this.selectVehicles =[];
						let obj = res.body.data
						this.pagesTotal = obj.pages
						this.vehicles = obj.list;
						this.$nextTick(()=>{
							this.$refs.laypg.setPage(obj.pageNum)
						})
						
						let arr = this.vehicles
						for(let i = 0;i < arr.length;i++){
							let tmpI = this.totalVehicles.findIndex(n=>n.id==arr[i].id)
							if(tmpI == -1){
								this.totalVehicles.push(arr[i])
								arr[i].checked = false;
							}else{
								arr[i].checked = this.totalVehicles[tmpI].checked
							}
							
						}	
					}
				}, res => {
					this.loadQueue = false
					this.$parent.openModal1(res.body.message)
				})
				.catch(res => {
					this.loadQueue = false
					this.$parent.openModal1(OPERATE_EXCEPTION)
				})
			},
			//锁定 解锁
			lock(vehicle){	
				let url = process.env.API_ROOT + "/monitor/track/tracks/right/"+vehicle.id +"/";//+vehicle.lockFlg==1?'0':'1';
				let b = vehicle.lockFlg==1?'0':'1';
				url = url +b;
				this.$http.put(url)
				.then( res => {
					if(res.body.success){
						//锁定时清除 选择框
						if(vehicle.lockFlg==0 && vehicle.checked){
							vehicle.checked = false;
							this.checked(vehicle);
						}
						vehicle.lockFlg=vehicle.lockFlg==1?0:1;
						return ;
					}
				}, res => {
					this.$parent.openModal1(res.body.message)
				})
				.catch(res => {
					this.$parent.openModal1(OPERATE_EXCEPTION)
				})
			},
			//移动到左边
			removeToMap(vehicle){
				if(this.$parent.getTrackCount()>=4){
					this.$parent.openModal1("追踪队列已满！请移除后再试")
					return ;
				}	
				this.$http.put(process.env.API_ROOT + '/monitor/track/tracks/left/'+vehicle.id+'/1')
				.then( res => {
					if(res.body.success){
						//通知父组件
						this.$emit('removeToMap',vehicle);
						//刷新队列
						this.refresh();
						return ;
					}
					this.$parent.openModal1(res.body.message)
					//移除失败 
				}).catch(res=>{
					this.$parent.openModal1(OPERATE_EXCEPTION)
					
				});
			},
			removeAll(){//清空队列
				this.$http.delete(process.env.API_ROOT + '/monitor/track/tracks')
				.then( res => {
					if(res.body.success){
						this.selectVehicles = []
						this.totalVehicles = []
							for(let i = 0,len = this.vehicles.length; i < len; i ++){
								this.vehicles[i].checked = false
							}
						//通知父组件
						this.$emit('removeAll',this);
						//刷新队列
						this.refresh();
						return ;
					}
					//移除失败 
					}, res => {
						this.$parent.openModal1(res.body.message)
					})
					.catch(res => {
						this.$parent.openModal1(OPERATE_EXCEPTION)
					})
			},
			checked(vehicle){//点击复选框 
				//取消了选择
				if(!vehicle.checked){
					let i =this.selectVehicles.findIndex(function(value, index, arr) {return value==vehicle.id;}); 
					if(i !=-1){ 
						this.selectVehicles.splice(i,1);
						let tmpI = this.vehicles.findIndex(n=>n.id==vehicle.id)
						this.vehicles[tmpI].checked = false
						let tmpI2 = this.totalVehicles.findIndex(n=>n.id==vehicle.id)
						this.totalVehicles[tmpI2].checked = false
					}
				}else{	
					let i =this.selectVehicles.findIndex(function(value, index, arr) {return value==vehicle.id;});
					if(i == -1){
						this.selectVehicles.push(vehicle.id);
						let tmpI = this.vehicles.findIndex(n=>n.id==vehicle.id)  
						this.vehicles[tmpI].checked = true
						let tmpI2 = this.totalVehicles.findIndex(n=>n.id==vehicle.id) 
						this.totalVehicles[tmpI2].checked = true
					}
				}
			},
			removeSelect(){//删除所选项
				if(this.selectVehicles.length != 0){
					this.$http.delete(process.env.API_ROOT + '/monitor/track/tracks',{body:this.selectVehicles})
					.then( res => {
						if(res.body.success){
							this.selectVehicles = []
							this.totalVehicles = []
							for(let i = 0,len = this.vehicles.length; i < len; i ++){
								this.vehicles[i].checked = false
							}
							//刷新队列
							this.refresh();
							return ;
						}
						//移除失败 
					}, res => {
						this.$parent.openModal1(res.body.message)
					})
					.catch(res => {
						this.$parent.openModal1(OPERATE_EXCEPTION)
					})
				}else{
					this.$parent.openModal1('请先选择要删除的车辆')
				}
			},
			selectAll(){//全选
				//通知父组件
				for(let i = 0,length = this.vehicles.length; i < length; i ++){
					this.getChecked(i)
				}	
			},
			invertSelect(){//反选
				for(let i = 0,length = this.vehicles.length; i < length; i ++){
					if(this.vehicles[i].checked){
						this.removeChecked(i)
					}else{
						this.getChecked(i)
					}
				}
			},
			getChecked(i){
				const tmpIndex = this.selectVehicles.findIndex(n=>n==this.vehicles[i].id)
				if(tmpIndex==-1){
					this.selectVehicles.push(this.vehicles[i].id)
					this.vehicles[i].checked = true
					this.vehicles.splice(i,1,this.vehicles[i])	
					let tmpI = this.totalVehicles.findIndex(n=>n.id==this.vehicles[i].id)
					if(tmpI != -1){
						this.totalVehicles[tmpI].checked = true
					}
				}
				
			},
			removeChecked(i){
				const tmpIndex = this.selectVehicles.findIndex(n=>n==this.vehicles[i].id)
				if(tmpIndex!==-1){
					this.selectVehicles.splice(tmpIndex,1)
					this.vehicles[i].checked = false
					this.vehicles.splice(i,1,this.vehicles[i])
					let tmpI = this.totalVehicles.findIndex(n=>n.id==this.vehicles[i].id)
					if(tmpI != -1){
						this.totalVehicles[tmpI].checked = false
					}
				}
			}
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// FollowQueue.vue?43c55564